module.exports = __webpack_public_path__ + "media/images/services/mb-53d63c8367db07864da98425df852947.svg";